<template>
  <div style="padding: 16px;background: #fff;">
    <!-- 工具栏 -->
    <div style="margin-bottom:10px;height:33px;">
      <a-button type="primary" @click="openDrawer('add')">
        <a-icon type="plus" />
        添加扣费策略
      </a-button>
    </div>
    <!-- 表格 -->
    <a-table
      :columns="columns"
      :dataSource="tableData"
      :bordered="true"
      :pagination="false"
      :loading="tableLoading"
      size="small"
    >
    </a-table>
    <!-- 添加修改测量侧推 -->
    <add-strategy-drawer
      :visible="drawerShowFlag"
      :detailData="drawerDetailData"
      :type="drawerType"
      @close="closeDrawer"
      @submit="sumitDrawer"
      :submitLoading="drawerSubmitLoading"
      :submitSuccess="drawerSubmitSuccess"
    ></add-strategy-drawer>
  </div>
</template>
<script>
import { groupBy } from '@/utils/base';
import addStrategyDrawer from './tpl/add-strategy';
import { getStrategyList, addStrategy, delStrategy, getStrategyDetail, editStrategy } from '@/apis/strategy';


export default {
  data() {
    return {
      tableData: [],
      columns: [
        {
          title: '策略名称',
          dataIndex: 'name',
          key: 'name',
          align: 'center',
          customRender: (text, row, index) => {
            if (row.idFlag === 1) {
              return {
                children: text,
                attrs: {
                  rowSpan: row.idLength
                }
              }
            } else {
              return {
                attrs: {
                  rowSpan: 0
                }
              }
            }
          }
        },
        {
          title: '餐次类别',
          dataIndex: 'diningType',
          key: 'diningType',
          align: 'center',
          customRender: (text, row, index) => {
            if (row.cycleFlag === 1) {
              return {
                children: text,
                attrs: {
                  rowSpan: row.cycleLength
                }
              }
            } else {
              return {
                attrs: {
                  rowSpan: 0
                }
              }
            }
          }
        },
        {
          title: '优惠类型',
          dataIndex: 'discountType',
          key: 'discountType',
          align: 'center',
          customRender: (text, row, index) => {
            if (row.cycleFlag === 1) {
              return {
                children: text,
                attrs: {
                  rowSpan: row.cycleLength
                }
              }
            } else {
              return {
                attrs: {
                  rowSpan: 0
                }
              }
            }
          }
        },
        {
          title: '优惠项',
          children: [
            {
              title: '优惠金额',
              key: 'discountMoney',
              dataIndex: 'discountMoney',
              align: 'center',
              customRender: (text, row, index) => {
                if (row.cycleFlag === 1) {
                  return {
                    children: text,
                    attrs: {
                      rowSpan: row.cycleLength
                    }
                  }
                } else {
                  return {
                    attrs: {
                      rowSpan: 0
                    }
                  }
                }
              }
            }, {
              title: '实际金额',
              key: 'actualMoney',
              dataIndex: 'actualMoney',
              align: 'center',
              customRender: (text, row, index) => {
                if (row.cycleFlag === 1) {
                  return {
                    children: text,
                    attrs: {
                      rowSpan: row.cycleLength
                    }
                  }
                } else {
                  return {
                    attrs: {
                      rowSpan: 0
                    }
                  }
                }
              }
            }
          ]
        },
        {
          title: '策略周期',
          children: [
            {
              title: '周期类型',
              key: 'cycleType',
              dataIndex: 'cycleType',
              align: 'center'
            }, {
              title: '优惠次数',
              key: 'discountCount',
              dataIndex: 'discountCount',
              align: 'center'
            }, {
              title: '限制刷卡次数',
              key: 'limitCount',
              dataIndex: 'limitCount',
              align: 'center'
            }
          ]
        },
        {
          title: '操作',
          key: 'action',
          width: 110,
          align: 'center',
          customRender: (text, row, index) => {
            if (row.idFlag === 1) {
              return {
                children: (<span>
                  <a href="javascript:;" on-click={() => { this.openDrawer('edit', row) }} >修改</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" on-click={() => { this.del(row) }} > 删除</a >
                </span >),
                attrs: {
                  rowSpan: row.idLength
                }
              }
            } else {
              return {
                attrs: {
                  rowSpan: 0
                }
              }
            }
          }
        }
      ],
      tableLoading: false,
      drawerShowFlag: false,
      drawerType: 'add',
      drawerSubmitLoading: false,
      drawerDetailData: {},
      drawerSubmitSuccess: false
    };
  },
  methods: {
    closeDrawer() {
      this.drawerShowFlag = false
    },
    openDrawer(type, item) {
      this.drawerType = type
      this.drawerShowFlag = true
      this.drawerSubmitSuccess = false
      if (type === 'edit') {
        this._detail(item.id)
      }
    },
    _detail(id) {
      getStrategyDetail({ id }).then(res => {
        if (res.data.state === 1) {
          this.drawerDetailData = res.data.attribute
        }
      })
    },
    // 删除
    del(item) {
      const that = this;
      that.$confirm({
        title: "您确定要删除这条扣费策略吗？",
        content: '删除后将不可撤销',
        onOk() {
          delStrategy({
            id: item.id
          }).then(res => {
            if (res.data.state === 1) {
              that.$message.success("删除成功");
              that._getStrategyList()
            }
          })
        }
      });
    },
    // 获取列表
    _getStrategyList() {
      this.tableLoading = true
      getStrategyList().then(res => {
        if (res.data.state === 1) {
          const result = res.data.attribute

          const resultGroupById = groupBy(result, item => item.id)

          let idFlag = 0;
          let currentItemId;
          let cycleFlag = 0;
          let currentItemCycle;
          this.tableData = result.map((item, index) => {
            if (currentItemId !== item.id) {
              currentItemId = item.id
              idFlag = 1
            } else {
              idFlag = 0
            }
            const itemCycle = item.id + item.publicMenuType
            if (itemCycle !== currentItemCycle) {
              currentItemCycle = itemCycle
              cycleFlag = 1
            } else {
              cycleFlag = 0
            }

            const resultGroupByCycle = groupBy(resultGroupById[item.id], item => item.publicMenuType)

            return {
              key: item.id + '_' + index,
              id: item.id,
              idFlag,
              idLength: resultGroupById[item.id].length,
              name: item.name,
              diningType: item.publicMenuType,
              cycleFlag,
              cycleLength: resultGroupByCycle[item.publicMenuType].length,
              discountType: item.discountType,
              discountMoney: item.discountValue2 ? `满${item.discountValue1}减${item.discountValue2}` : item.discountValue1,
              actualMoney: item.actAmount,
              cycleType: item.periodType || '-',
              discountCount: item.periodType ? item.disCount : '-',
              limitCount: item.periodType ? item.limitCount : '-'
            }
          })
        }
        this.tableLoading = false
      })
    },
    // 提交
    sumitDrawer(submitData) {
      this.drawerSubmitLoading = true
      if (this.drawerType === 'add') {
        addStrategy({
          strategys: JSON.stringify(submitData)
        }).then(res => {
          if (res.data.state === 1) {
            this.$message.success("提交成功");
            this.drawerSubmitSuccess = true
            this.closeDrawer()
            this._getStrategyList()
          } else {
            this.drawerSubmitSuccess = false
          }
          this.drawerSubmitLoading = false
        })
      } else if (this.drawerType === 'edit') {
        editStrategy({
          strategys: JSON.stringify(submitData)
        }).then(res => {
          if (res.data.state === 1) {
            this.$message.success("提交成功");
            this.drawerSubmitSuccess = true
            this.closeDrawer()
            this._getStrategyList()
          } else {
            this.drawerSubmitSuccess = false
          }
          this.drawerSubmitLoading = false
        })
      }
    }
  },
  mounted() {
    this._getStrategyList()
  },
  components: {
    addStrategyDrawer
  }
};
</script>

<style lang="less">
.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}
</style>
